import styled from "styled-components";
import InputField from "../../components/InputField";
import SelectField from "../../components/SelectField";
import DateRangePickerInput from "../../components/DateRangePickerInput";
import TravelTimeSelect from "./TravelTimeSelect";
import TravelClassSelect from "./TravelClassSelect";
import Checkbox from "../../components/Checkbox";
import { Colors } from "../../config";
import { DESTINATION_COUNTRIES } from "../../config/Constants";
import Destination from "./Destination";
import { useState } from "react";
import { ErrorText } from "./new";
import InputDatePicker from "../../components/Datepicker";

const from = require("../../assets/images/from_blue.png");
const to = require("../../assets/images/to_blue.png");

const TravelDetails = ({
  onDateSelection,
  airlines,
  setTravelClass,
  handleCheckAirlines,
  formData,
  // onFormChange,
  onTimeRangeSelect,
  onDirectFlightToggle,
  destinations,
  onDestinationSelect,
  fieldError,
  country,
  onFromSelect,
  workTerritoryName
}) => {
  return (
    <BookingWrapper>
          <InputWrapper>
        <Destination
          data={formData?.returnJourney ? destinations.filter((country)=>country.country === workTerritoryName) :destinations}
          value={destinations?.filter((de) => formData.from === de.value)[0]}
          onSelect={onFromSelect}
          helperText={fieldError.from}
          country={formData?.returnJourney ? workTerritoryName : country}
          icon={from}
          label={"From"}
        />
      </InputWrapper>
      <InputWrapper>
        <Destination
          data={destinations}
          value={destinations?.filter((de) => formData.to === de.value)[0]}
          onSelect={onDestinationSelect}
          helperText={fieldError.to}
          country={country}
          icon={to}
          label={"Destination"}
        />
      </InputWrapper>
      <InputWrapper>
        {formData?.returnJourney ? (
          <DateRangePickerInput
            label="Departure & Return Date"
            onDateSelection={onDateSelection}
            start={formData.departureDate}
            end={formData.returnDate}
            minDate={new Date()}
            helperText={fieldError.departureReturnDate}
          />
        ) : (
          <InputDatePicker
            format="ccc dd-MM-yyyy"
            placeholder="Select Date"
            label="Departure Date"
            value={
              formData.departureDate ? new Date(formData.departureDate) : ""
            }
            onChange={(val) => onDateSelection(val)}
            minDate={new Date()}
            scrollableYearDropdown
            scrollableMonthDropdown
            dropdownMode="select"
            hideIcon
            placeHolderColor
            helperText={fieldError.departureReturnDate}
          />
        )}
      </InputWrapper>
      <InputWrapper>
        <TravelTimeSelect
          returnTime={formData.returnTime}
          returnJourney={formData.returnJourney}
          departureTime={formData.departureTime}
          onTimeRangeSelect={onTimeRangeSelect}
          helperText={fieldError.departureTime || fieldError.returnTime}
        />
      </InputWrapper>

      <TravelClassSelect
        airlines={airlines}
        onClassSelect={setTravelClass}
        onCheck={handleCheckAirlines}
        helperText={fieldError.perferAirline}
      />
      <CheckboxWrapper>
        <Checkbox
          label="Direct Flights Only"
          fontColor={Colors.shark}
          setIsChecked={onDirectFlightToggle}
          isChecked={formData.directFlight}
        />
      </CheckboxWrapper>
    </BookingWrapper>
  );
};

const BookingWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 2rem;
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 1rem;
  }
`;

const InputWrapper = styled.div`
  width: 100%;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media only screen and (max-width: 768px) {
    justify-content: flex-start;
  }
`;

export default TravelDetails;
